import React, { FunctionComponent } from 'react'
import NoMatchView from './NoMatchView'

const NoMatch: FunctionComponent = () => {
  return <NoMatchView />
}

export default NoMatch
